import React from 'react';
import '../assets/css/index.css';

export default()=>{
    return (
        <section className="what-w3ls">
                <div className="container-fluid py-xl-5 py-lg-3">
                    <div className="offset-xl-7 offset-lg-6 offset-md-4 offset-sm-2">
                        <div className="grids-whtas pr-xl-5">
                            <h3 className="tittle text-wh mb-5 font-weight-bold">10+ mango varieties, farm products</h3>
                            <p className="lead text-li">Fresh From Our Farm located in a village named Vaikuntham at Salem.</p>
                            <hr className="my-4" />
                            <p className="text-li">Prepared by farmers,packed hygenically at our stores and sold online with our website.
                            Sharing the sweetness of Salem Mangoes worldwide is our pride.</p>
                        </div>
                    </div>
                </div>
            </section>
    )
}